import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import GS from '../../grafsync/grafsync';
import { NS_GS } from '../utils/constants';
import CreateGroupDialog from './CreateGroupDialog';

class CreateGroupDialogContainer extends Component {

  addGroup = async (label) => {
    const groupIRI = NS_GS + "usergroup/" + uuidv4();
    const newGroup = {
      id: groupIRI,
      type: "UserGroup",
      label: {
        en: label
      }
    };
    await GS.insertResource(newGroup, groupIRI, GS.getActiveSubscription());
    this.props.onCreateGroup(groupIRI);
  };

  render() {

    return (
      <CreateGroupDialog graph={GS.getActiveSubscription()} onAddGroup={this.addGroup} />
    );
  }

}

CreateGroupDialogContainer.propTypes = {
  onCreateGroup: PropTypes.func.isRequired
};

export default CreateGroupDialogContainer;